export default "__VITE_ASSET__Dhy0$DJP__"